import ReportView from './ReportView';

/**
 * Visit report — one row per visit, with the visit form's custom fields
 * and the customer's custom fields available as columns.
 */
export default function VisitReportPage() {
  return (
    <ReportView
      title="Visit report"
      subtitle="Every visit in a range, with the columns you choose — including your own form fields."
      endpoint="/reports/visits"
      storageKey="report.cols.visits"
      exportName="visit-report"
      defaultColumns={['visitDate', 'salesman', 'customer', 'route', 'status', 'outcome', 'durationMin']}
      statusOptions={[
        { value: 'completed', label: 'Completed' },
        { value: 'in_progress', label: 'In progress' },
        { value: 'abandoned', label: 'Abandoned' },
      ]}
    />
  );
}
